module.exports = __webpack_public_path__ + "media/assets/img/flags/sk-SK-525742aa4008ad1cc7f717f476353249.png";